import { isCharacterEntity } from "../entities";
import { Client } from "../service/esiclient";
import { fetchFirstCharacterID } from "./tokenhelper";
import { Cache } from "memory-cache";

const esiClient = new Client();
const cache = new Cache();

export const character_id_check = async (character_id_or_entity: any) => {
  if (character_id_or_entity === null && !isCharacterEntity(character_id_or_entity)) {
    return await fetchFirstCharacterID();
  } else {
    if (isCharacterEntity(character_id_or_entity)) {
      return character_id_or_entity.properties.id.basicValue;
    } else if (!isNaN(character_id_or_entity)) {
      return character_id_or_entity;
    } else if (parseInt(character_id_or_entity.basicValue) > 0) {
      return character_id_or_entity.basicValue;
    } else {
      return 0;
    }
  }
};

export const character_id_or_entity_corporation = async (character_id_or_entity: any) => {
  let character_id = 1;
  let corporation_id = 1;
  if (character_id_or_entity === null) {
    character_id = await fetchFirstCharacterID();
  } else {
    if (isCharacterEntity(character_id_or_entity)) {
      character_id = character_id_or_entity.properties.id.basicValue;
    } else if (parseInt(character_id_or_entity.basicValue) > 0) {
      character_id = character_id_or_entity.basicValue;
    } else if (!isNaN(character_id_or_entity)) {
      character_id = character_id_or_entity;
    } else {
      character_id = 1;
    }
  }
  if (character_id > 1) {
    const affiliationDataFromCache: any = cache.get("corp-" + character_id);
    if (affiliationDataFromCache == null) {
      const affiliationData = await esiClient.post_characters_affiliation([character_id], null);
      cache.put("corp-" + character_id, affiliationData, 60 * 60 * 3600);
      const newLocal = affiliationData.find((x) => x.character_id === character_id)?.corporation_id;
      if (typeof newLocal == "number") corporation_id = newLocal;
    } else {
      const newLocal = affiliationDataFromCache.find((x: any) => x.character_id === character_id)?.corporation_id;
      if (typeof newLocal == "number") corporation_id = newLocal;
    }
  }
  return { character_id, corporation_id };
};
